import React from 'react';

function Hero() {
  return (
    <section className="hero">
      <h1>PixelArcade</h1>
      <p>Experience the thrill of retro gaming, reimagined for the modern player.</p>
      <button className="cta-button">Start Playing</button>
    </section>
  );
}

export default Hero;